export const ratestrip = {
    widgetReady: false,
};
